import { useActivityPageContext } from "PFApp/activities/show/activity_page_context";
import { useTemplate } from "PFApp/hooks";

export const useActivityTemplate = () => {
  const { task: activity } = useActivityPageContext();
  return useTemplate(activity?.template_id);
};
